/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import LocalizationComponent from '../../../Localization/LocalizationComponent';
import ComponentBase from '../../ComponentBase';
import CLog, { LogTypes } from '../../ComponentLogger';
import UpdateableComponentBase from './UpdateableComponentBase';
import ClassUtil from '../../ClassUtil';

/**
 * Implementation of [[UpdateableComponentBase]] for updating [[cc.EditBox]]es
 * when a target observable changes.
 */
@cc._decorator.ccclass
export default class UpdateableEditBoxComponent extends UpdateableComponentBase<cc.EditBox, any>
{
    /** The Label or RichText to update when the target observable changes. */
    protected component: cc.EditBox = null;
    public get Component(): cc.EditBox { return this.component; }

    /** @hidden */
    protected setContexts(): void
    {
        this.localRef.SetContext(LocalizationComponent);
    }

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.component = ComponentBase.GetFirstComponent<cc.EditBox>(this.node, cc.EditBox);

        this.AddComponentEventHandler(
            ClassUtil.getName(UpdateableEditBoxComponent),
            'text-changed',
            text => this.TextChanged(text),
            this.component.textChanged
        );

        if (!this.component)
        {
            CLog.error("No EditBox component. Disabled.", this, LogTypes.Initialization);
            this.enabled = false;
            return;
        }
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        this.updateUI();
    }

    /** @hidden */
    protected updateUI = (event?: cc.Event.EventCustom): void =>
    {
        if (!this.component
                || !this.observable
                || !this.observable.HasValue()) { return; }

        this.setEditBoxString(this.observable.Value);
    }

    public TextChanged(text: string): void
    {
        if (this.observable.Value === text) { return; }
        this.observable.Value = text;
    }

    private setEditBoxString = (value: string): void =>
    {
        this.component.string = value;
    }

    /** If the target observable is value restricted, bumps it to the next highest valid value. */
    public IncreaseValue(): void
    {
        if (!this.observable) { return; }

        this.observable.SetNextHigherValidValue();
    }

    /** If the target observable is value restricted, bumps it to the next lowest valid value. */
    public DecreaseValue(): void
    {
        if (!this.observable) { return; }

        this.observable.SetNextLowerValidValue();
    }
}
